module.exports = __webpack_public_path__ + "87a243193195097898ae827d24ced332.svg";